import React, { Fragment } from 'react';
import './landingFooter.less';
import NavigationAnchor from './NavigationAnchor';
import NavigationItemsEnum, { INavigationItem } from './NavigationItemsEnum';

function LandingFooter(): JSX.Element {
	const renderNavItem = (navItem: INavigationItem): JSX.Element => {
		return <NavigationAnchor {...navItem} />;
	};

	return (
		<div className="landing-footer-container">
			<div className="spacer">&nbsp;</div>
			<div className="landing-footer">
				<div className="columns">
					{Object.keys(NavigationItemsEnum).map((navItem, i) => (
						<Fragment key={i}>
							{renderNavItem(NavigationItemsEnum[navItem])}
						</Fragment>
					))}
				</div>
			</div>
		</div>
	);
}

export default LandingFooter;
